// src/Logo.js
import React from 'react';

const Logo = () => (
    <div className="logo">
    <img src={require('./assets/wizard20.png')} alt="Logo" />
  </div>
);

export default Logo;